import React from "react";
import { DATE_RANGE } from "../../../constants/picker-entries-constants";
import i18n from "../../../constants/i18n";
import getShareholderStore from "../../../stores/shareholder-store";
import { TEt3PickerSingleValue } from "../../../TypesNEW";
import Et3Button from "../../../core/et3-button";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import Et3Picker from "../../../core/et3-input/et3-picker";

const ShareholderForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={300}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("DATE_RANGE")}
          options={DATE_RANGE}
          value={getShareholderStore().dateRangeMonths.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getShareholderStore().setDateRange(value);
          }}
          style={{}}
          isMultiple={false}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        onClick={async () => {
          await getShareholderStore().getShareholderUpdateData();
        }}
        isEnabled={true}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </React.Fragment>
  );
});

export default ShareholderForm;
